import { ActionIcon, ActionIconProps, Button, ButtonProps } from "@mantine/core"
import { useBreakpoints } from "../../../../../utils/use-breakpoints"

type ResponsiveActionIconButtonProps = {
  icon: React.ReactNode
  buttonProps: ButtonProps & { onClick?: () => void }
  actionIconProps: ActionIconProps & { onClick?: () => void }
}

/**
 * Renders an ActionIcon if xs or sm and a Button otherwise
 */
export const ResponsiveActionIconButton = React.forwardRef<
  HTMLButtonElement,
  ResponsiveActionIconButtonProps
>(
  (
    {
      icon,
      buttonProps,
      actionIconProps,
      ...props
    }: ResponsiveActionIconButtonProps,
    ref
  ) => {
    const { xs, sm } = useBreakpoints()
    return xs || sm ? (
      <ActionIcon ref={ref} {...props} {...actionIconProps}>
        {icon}
      </ActionIcon>
    ) : (
      <Button ref={ref} leftSection={icon} {...props} {...buttonProps} />
    )
  }
)
